import MessagesListPage from "@/features/chat/messages-list.page";
import { isProjectFeatureEnabled } from "@/features/projects/utils/project-features";
import { projectHomeRedirect } from "@/features/projects/utils/project-home-destination";
import { IncognitoProjectListPage } from "@/features/superuser/incognito/project/incognito-project-list.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/messages/",
)({
  beforeLoad: ({ context, params }) => {
    if (!isProjectFeatureEnabled(context.project, "show_team_messages")) {
      // CR-144: straight to the project's resolved home, not the bare root.
      throw projectHomeRedirect(context.project, params, context.workspaceAccess);
    }
  },
  component: MessagesListPageRoute,
});

// CR-165: incognito mode gets the display-only list (no create, no delete, no
// members dialog); the member page is untouched.
function MessagesListPageRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();

  if (workspaceAccess.mode === "incognito") {
    return <IncognitoProjectListPage project={project} kind="messageRooms" />;
  }

  return <MessagesListPage />;
}
